import React, { useEffect, useRef, useState } from 'react'
import { Menu } from '@services/api/menus'
import { Logo } from '@components/logo'
import { MenuContent } from '@components/shared/menu/menu-content'
import { MenuIcon } from '@components/shared/menu/menu-icon'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { useWindowDimensions } from '@hooks/use-window-dimensions'
import cl from 'classnames'

interface HeaderProps {
  menus: Menu[]
  title?: string
  logoUrl?: string
  logoHeading?: boolean
  isFixed?: boolean
}

export const Header: React.FC<HeaderProps> = ({
  menus,
  title,
  logoHeading = false,
  logoUrl,
  isFixed
}) => {
  const router = useRouter()
  const menuRef = useRef(null)
  const { width, height } = useWindowDimensions()

  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false)
  const [isVisibleButton, setIsVisibleButton] = useState(false)
  const isMobile = width < 768

  const isIndexPage = router.pathname === '/'

  const [show, setShow] = useState(true)
  const [lastScroll, setLastScroll] = useState(0)
  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY

      // Se está no topo → oculta
      if (currentScroll === 0) {
        setShow(true)
        setLastScroll(currentScroll)
        return
      }

      // Se está rolando para cima → mostra
      if (currentScroll < lastScroll) {
        setShow(true)
      } else {
        // Se está rolando para baixo → esconde
        setShow(false)
      }

      setLastScroll(currentScroll)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScroll])
  useEffect(() => {
    function handleClickOutside(event: Event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        isMenuOpen
      )
        setIsMenuOpen(false)
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [menuRef, isMenuOpen])

  useEffect(() => {
    const handleScroll = () => {
      if (snapDiv.scrollTop < height / 2)
        return isVisibleButton && setIsVisibleButton(false)
      return !isVisibleButton && setIsVisibleButton(true)
    }

    if (isMobile) return setIsVisibleButton(true)
    const snapDiv = document.getElementById('snap-div')
    if (!snapDiv) return

    handleScroll()
    snapDiv.addEventListener('scroll', handleScroll)
    return () => snapDiv.removeEventListener('scroll', handleScroll)
  }, [height, isVisibleButton, isMobile])

  useEffect(() => {
    setIsMenuOpen(false)
  }, [router.asPath])

  return (
    <header
      ref={menuRef}
      className={cl(
        'w-full min-h-[56px] flex flex-col font-myriad touch-none z-50',
        {
          'h-14': !isMenuOpen,
          'fixed top-0': isFixed
        }
      )}
    >
      <div className="w-full h-14 min-h-[56px] flex flex-col items-center bg-white z-50 xl:px-8">
        <div className="w-full h-full max-w-7xl max-h-[56px] grid grid-cols-[100px_1fr_28px] md:grid-cols-3 py-2 px-4 md:px-8 xl:px-0">
          <div className="order-3 md:order-1 flex items-center justify-end md:justify-start">
            {menus && !!menus?.length && (
              <MenuIcon isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
            )}
          </div>

          <div className="order-1 md:order-2 flex flex-col items-center justify-center">
            {logoHeading ? (
              <Logo logoUrl={logoUrl} title={title} />
            ) : (
              <Logo logoUrl={logoUrl} title={title} />
            )}
          </div>

          <div className="order-2 md:order-3 flex items-center justify-end">
            {/* {isIndexPage ? (
              <Link
                href="/curso-de-energia-solar"
                className={`w-fit flex items-center justify-center ${
                  isVisibleButton || isMenuOpen
                    ? 'opacity-100 visible'
                    : 'opacity-0 invisible'
                }  bg-gradient-to-r from-v3-orange-350 to-v3-orange-500 hover:brightness-105 pb-1.5 pt-2 text-[10px] md:text-base leading-4 tracking-[1.2px] font-semibold rounded-full px-4 md:px-6 transition-all duration-300`}
              >
                CURSOS DE ENERGIA SOLAR
              </Link>
            ) : ( */}
            <Link
              href="/curso-de-energia-solar"
              className="w-fit h-8 md:h-10 flex items-center justify-center bg-gradient-to-r from-v3-orange-350 to-v3-orange-500 hover:brightness-105 text-[10px] md:text-base leading-4 tracking-[1.2px] font-semibold rounded-full px-4 md:px-6 transition-all duration-300"
            >
              CURSOS DE ENERGIA SOLAR
            </Link>
            {/* )} */}
          </div>
        </div>
      </div>
      <div
        className={`
        w-full bg-white h-24 flex justify-center items-center font-bold
        transition-all duration-300
        ${
          show
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 -translate-y-10 pointer-events-none'
        }
      `}
      >
        {isIndexPage ? (
          <h1 className="text-[#898989]">
            <span className="absolute text-transparent">Portal Solar - </span>A
            Marca <span className="text-[#FF9C00] font-extrabold">Líder</span>{' '}
            em Energia Solar
          </h1>
        ) : (
          <div className="text-[#898989]">
            A Marca <span className="text-[#FF9C00] font-extrabold">Líder</span>{' '}
            em Energia Solar
          </div>
        )}
      </div>

      {menus && menus?.length > 0 && (
        <div
          className={`w-full absolute flex flex-col items-center bg-white ${
            isMenuOpen
              ? 'translate-y-0 opacity-100'
              : '-translate-y-full opacity-0'
          }  z-40 pt-14 xl:px-8 transition-all duration-500 md:border-b-[1px] md:border-gray-50`}
        >
          <MenuContent content={menus} />
        </div>
      )}
    </header>
  )
}
